function marketoSubmit (APIState, _model) {
  return new Promise((resolve, reject) => {
    if (window.location.hostname === "localhost") {
      resolve();
      return;
    }

    if (!window.MktoForms2) {
      reject(new Error('MktoForms2 is not defined'));
      return;
    }

    const marketoBaseUrl = 'https://go.iterable.com';
    const { formid, munchkinId } = APIState;

    APIState.marketingConsent = JSON.stringify(
      APIState.marketingConsent === 'true'
    )

    const sendEmail = () => {
      if (!_model) {
        return
      }

      const emailData = {
        'wp_email_to': 'forms@iterable.com',
        'wp_email_message': JSON.stringify(APIState, null, 4),
        'wp_email_subject': `Activate Live Submission: Success`
      }

      _model.model__handleEmailSubmission(emailData).always(response => {
        console.log('email response ', response);
      });
    }

    sendEmail();

    window.MktoForms2.loadForm(
      marketoBaseUrl,
      munchkinId,
      formid,
      form => {
        form.vals(APIState);
        form.addHiddenFields(APIState);

        form.onValidate(valid => {
          if (!valid) {
            reject(new Error('Marketo form validation failed.'));
          }
        });

        form.onSuccess(() => {
          resolve();

          document.dispatchEvent(new CustomEvent("itbl.marketoSubmitted", {bubbles: true}));

          return false;
        });

        form.submit();
      }
    );
  });
}
